import { style } from "typestyle";
import { colors } from "styles/styles";

export const consent = style({
  padding: "1rem",
  display: "flex",
  fontSize: "19px",
  flexDirection: "column",
  borderRadius: "9px",
  boxShadow: `0 3px 5px ${colors.hooplaShadowColor}`,
  backgroundColor: colors.hooplaBackground,

  $nest: {
    "&:not(:last-child)": {
      marginBottom: "12px"
    }
  }
});

export const row = style({
  display: "flex",
  justifyContent: "space-between"
});

export const expiry = style({
  marginTop: "1rem",
  alignSelf: "flex-end"
});

export const text = style({
  paddingRight: "3rem"
});
